export default __webpack_public_path__ + "static/media/DeepakFull.47dea80a.webp";